import { usePageTitle } from "@/hooks/usePageTitle";

const Shell = ({ title, testId, children }) => (
  <div className="max-w-3xl mx-auto px-6 py-20" data-testid={testId}>
    <h1 className="text-4xl md:text-5xl font-bold">{title}</h1>
    <div className="mt-8 space-y-6 text-lg leading-relaxed text-foreground">{children}</div>
  </div>
);

export const Privacy = () => {
  usePageTitle("Privacy | One More Shift", "Privacy policy for One More Shift, starting local in the communities south and southeast of Houston.");
  return (
    <Shell title="Privacy" testId="privacy-page">
      <p>
        One More Shift collects the information you choose to share through our forms — such as your name, contact
        details, and the experience or needs you describe — solely to build and operate our founding local network.
      </p>
      <p>
        Advisor applications are never displayed publicly. We do not sell your information. Submissions are reviewed
        only to understand where your experience might fit or whether we can identify relevant experience for a
        request.
      </p>
      <p>
        This site is in its founding stage. A full privacy policy will be published before launch. Questions?
        Reach us through the forms on this site.
      </p>
    </Shell>
  );
};

export const Terms = () => {
  usePageTitle("Terms | One More Shift", "Terms of use for One More Shift, starting local in the communities south and southeast of Houston.");
  return (
    <Shell title="Terms" testId="terms-page">
      <p>
        One More Shift is currently building its founding local network in the communities south and southeast of
        Houston. Submitting a form on
        this site expresses interest only — it does not create an engagement, employment relationship, or any
        guarantee of work or of a match.
      </p>
      <p>
        Certain services may require licenses, certifications, background checks or other qualifications, and
        availability will depend on the engagement. One More Shift does not provide medical, psychological or
        professional child-development advice.
      </p>
      <p>Full terms of service will be published before launch.</p>
    </Shell>
  );
};
